import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import colors from '../../../../assets/colors'
import { ColorBox, ColorPicker } from 'material-ui-color'
import { useDispatch } from 'react-redux'
import {
  fetchServiceCategory,
  post,
  show,
  update,
} from '../../../service-category/ServiceCategoryActions'
import { SNACKBAR } from '../../../main/MainActions'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import fontSizes from '../../../../assets/fontSizes'
import { useHistory, useLocation } from 'react-router-dom'
import { useQueryParams } from '../../../../util/utils'
import Icon from '@mdi/react'
import { mdiGiftOpenOutline } from '@mdi/js'

const ModalServiceCategory = ({ open, handleClose, isEdit, id }) => {
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const [form, setForm] = useState({
    id: id || '',
    name: '',
    color: '',
    status: 1,
    cashback_conversion: '',
  })

  const [error, setError] = useState({
    error: false,
    message: '',
  })

  const dispatch = useDispatch()

  const styles = filterStylesComponents()

  const handleChange = e => {
    e.preventDefault()

    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value,
    })
  }

  const onSubmit = e => {
    e.preventDefault()

    if (!form.name) {
      return setError({
        error: true,
        message: 'Campo obrigatório',
      })
    }

    return dispatch(update(form)).then(data => {
      if (data && data.code === 200) {
        const finalFilters = {
          ...filters,
          status: 1,
        }

        dispatch(
          fetchServiceCategory({
            ...finalFilters,
            page: filters?.page || 1,
            rows: filters?.rows || 10,
          })
        )
        handleClose()
      }
    })
  }

  useEffect(() => {
    setForm({ name: '', color: '#FF0000', status: 1, cashback_conversion: '' })

    if (id && isEdit && open) {
      const getService = async () => {
        try {
          const data = await show(id)

          if (data?.data) {
            setForm({
              ...form,
              id: data?.data?.id,
              name: data?.data?.name,
              status: data?.data?.status,
              color: data?.data?.color,
              cashback_conversion: data?.data?.cashback_conversion || '',
            })
          }
        } catch (e) {
          dispatch({
            ...SNACKBAR.HARDFAIL,
            error: { message: 'Falha ao buscar serviço' },
          })
        }
      }

      getService()
    }
  }, [open])

  return (
    <BaseFilterModal handleOpen={handleClose} open={open} hiddenBaseStructure>
      <Box
        style={{
          borderRadius: 'inherit',
          padding: '1em',
          width: '520px',
          minHeight: '24vh',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              style={{
                borderRadius: '1.2em',
                padding: '1em',
                backgroundColor: colors.lightGray,
              }}
            >
              <Grid container spacing={2}>
                <Grid item>
                  <Typography
                    style={{
                      color: colors.primary,
                    }}
                  >
                    <Icon path={mdiGiftOpenOutline} size={2.5} />
                  </Typography>
                </Grid>

                <Grid item xs>
                  <Grid
                    container
                    justifyContent="space-between"
                    direction="column"
                    spacing={1}
                  >
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          fontSize: '20px',
                          fontWeight: 'bold',
                          color: colors.primary,
                          letterSpacing: '1.02px',
                        }}
                      >
                        {form?.name || 'Categoria'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          color: colors.textGray,
                        }}
                      >
                        Utilize o campo abaixo para alterar a conversão do
                        cashback
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <form
                  style={{ width: '100%', height: '100%' }}
                  onSubmit={onSubmit}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box
                        style={{
                          fontSize: '14px',
                          display: 'flex',
                          gap: 2,
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '16px',
                            color: colors.primary,
                            letterSpacing: '1.02px',
                          }}
                        >
                          A cada 100 reais o cliente ganha:
                        </Typography>

                        <TextField
                          name="cashback_conversion"
                          type="number"
                          inputProps={{
                            step: '0.01',
                            min: '0',
                            max: '100',
                            style: { width: '80px', textAlign: 'center' },
                          }}
                          value={form.cashback_conversion}
                          onChange={handleChange}
                          InputLabelProps={{
                            style: { color: colors.graylight },
                          }}
                        />

                        <Typography
                          style={{
                            fontSize: '16px',
                            color: colors.primary,
                            letterSpacing: '1.02px',
                          }}
                        >
                          pontos.
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid
                        container
                        alignItems="flex-end"
                        justifyContent="flex-end"
                      >
                        <Grid item>
                          <Button
                            className={styles.btnAdd}
                            type="submit"
                            style={{
                              fontSize: fontSizes.text,
                              padding: '4px 16px',
                            }}
                          >
                            Salvar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </BaseFilterModal>
  )
}

export default ModalServiceCategory
